import { Component, OnInit, ViewChild } from "@angular/core";
import { DataService } from "../../data.service";
import { Vente } from "../../model/vente";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { Achat } from '../../model/achat';
import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../authentication.service';
import { DataBase } from "src/app/model/dataBase";
import { Charge } from "src/app/model/charge";
import { Avoir } from "src/app/model/avoir";
import { Depot } from "src/app/model/depot";
@Injectable()
// import mysqldump from 'mysqldump';
// mysqldump({
//   connection: {
//       host: 'localhost',
//       user: 'root',
//       password: '',
//       database: 'dregrie',
//   },
//   dumpToFile: './dump.sql',
// });
// or const mysqldump = require('mysqldump')
 
// dump the result straight to a file

@Component({
  selector: "app-venteMois",
  templateUrl: "venteMois.component.html",
  styleUrls: ["venteMois.component.scss"],
})

export class VenteMoisComponent implements OnInit {
  myUrl: string = `${environment.urlApi}`;
  Vente       : Vente = {};
  Ventes      : Vente[];  
  Paiements   : Vente[]; 
  PaiementsFiltered : Vente[];  
  Charge      : Charge = {};
  Charges     : Charge[];  
  ChargesFiltered     : Charge[];  
  Avoir       : Avoir = {};
  Avoirs      : Avoir[];
  AvoirsFiltered      : Avoir[];
  Depot       : Depot = {};
  Depots      : Depot[];
  Donnees     : DataBase [];
  DonneesFiltered     : DataBase [];
  Remises     : DataBase [];
  RemisesFiltered     : DataBase [];
  Donnee      : DataBase = {};
  dataTable   : string;
  tableArticles: Achat[];
  idDepot     : number;
  Achat: Achat = {};
  Achats: Achat[];
  AchatsFiltered: Achat[];
  dataChartDay: any;
  dataChartPersonnel: any;
  able: boolean =false;
  depotActivate: boolean =false;
  styleOBJ:any;
  // data: any;
  basicData: any;
  basicOptions: any;
  totalCharge :number=0;
  totalVente :number=0;
  totalRemise :number=0;
  totalAvance :number=0;
  totalAvoir :number=0;
  constructor(
    private http:HttpClient, 
    private data: DataService, 
    public AuthenticationService: AuthenticationService,
    private router: Router) {}
  performGetEx():Observable<any>{
    return this.http.get<any>(`${this.myUrl}/api/api/backup.php`);
}
public innerWidth: any;
public innerHeight: any;
public innerHeightCard: any;
public widthh: any;
  ngOnInit() {
    // this.venteChartMonth();
    this.depot();
    this.donnee();
    if(this.AuthenticationService.currentUserValue.groupe=='Administrateur' || this.AuthenticationService.currentUserValue.groupe=='Administrateurs' ){
      this.able=true;
    }
    if(this.AuthenticationService.currentUserValue.depot== true){
      this.depotActivate=true;
    }

    this.innerWidth = window.innerWidth; 
		this.innerHeight = (window.innerHeight-130) +"px";
    this.innerHeightCard = (window.innerHeight-95) +"px";
    this.widthh =  this.innerWidth *5;
    // this.styleOBJ = {'background-color':'007AD9'}
    this.styleOBJ = {'background-image':'linear-gradient(to bottom,#007AD9,#007AD0, white)'}
    // alert("innerWidth" + this.innerWidth);
		// alert("innerHeight" + this.innerHeight);
		// alert("Screen width is " + screen.width + " Screen Hieth is " + screen.height);
		// alert("Screen width is " + window.innerWidth + " Screen Hieth is " + window.innerHeight);
    // this.venteChartDay();
    // this.venteChartPersonnel();
    // this.getStock();
  }
  depot() {
    this.Depot.action = "Select";
    this.Depot.DBase  = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .depot(this.Depot)
      .toPromise()
      .then((x: Depot[]) => {this.Depots = x});
  }
  donnee() {
    this.Donnee.action = "SelectRecapByMonth";
    this.dataTable = "vente";
    this.Donnee.DBase = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .donnee(this.dataTable,this.Donnee)
      .toPromise()
      .then((x: DataBase[]) => (this.Donnees = x,this.DonneesFiltered = x,  this.remiseChartMonth()));
  }
  remiseChartMonth() {
    this.Donnee.action = "SelectRecapByMonthRemise";
    this.dataTable = "vente";
    this.Donnee.DBase = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .donnee(this.dataTable,this.Donnee)
      .toPromise()
      .then((x: DataBase[]) => (this.Remises = x,this.RemisesFiltered = x,  this.paiementChartMonth()));
  }
  paiementChartMonth() {
    this.Donnee.action = "SelectRecapByMonth";
    this.dataTable = "paiementClient";
    this.Donnee.DBase = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .donnee(this.dataTable,this.Donnee)
      .toPromise()
      .then((x: Vente[]) => (this.Paiements= x,this.PaiementsFiltered= x,this.chargeChartMonth()));
  }
  chargeChartMonth() {
    this.Donnee.action = "SelectRecapByMonth";
    this.dataTable = "charge";
    this.Donnee.DBase = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .donnee(this.dataTable,this.Donnee)
      .toPromise()
      .then((x: DataBase[]) => (this.Charges= x,this.ChargesFiltered= x,this.avoirChartMonth()));
  }
  avoirChartMonth() {
    this.Donnee.action = "SelectRecapByMonth";
    this.dataTable = "avoir";
    this.Donnee.DBase = this.AuthenticationService.currentUserValue.DBase;
    this.data
      .donnee(this.dataTable,this.Donnee)
      .toPromise()
      .then((x: DataBase[]) => (this.Avoirs= x,this.AvoirsFiltered= x,this.setDepot()));
  }
  setDepot(){
    let rechercheDepot = this.Depots.find((x) => x.designation == "MAGASIN");  
    if(rechercheDepot){
      this.idDepot=rechercheDepot.id;
      this.findDepot(this.idDepot);
    }else{
      this.idDepot=3;
      this.findDepot(this.idDepot);
    }
  }
  findDepot(idDepot){  
    if (idDepot) {
      this.DonneesFiltered    = this.Donnees.filter((x) => x.idDepot==idDepot);   
      this.RemisesFiltered    = this.Remises.filter((x) => x.idDepot==idDepot);   
      this.PaiementsFiltered  = this.Paiements.filter((x) => x.idDepot==idDepot);  
      this.AvoirsFiltered     = this.Avoirs.filter((x) => x.idDepot==idDepot);
      this.ChargesFiltered    = this.Charges.filter((x) => x.idDepot==idDepot);
      this.chartDay();      
    }
  }

  chartDay() {
    var label = [];
    var donnee = [];
    var charge = [];
    var avoir = [];
    var avance = [];
    var remise = [];
    this.totalVente=0;
    this.totalVente = this.DonneesFiltered.map((t) => t.vente * 1).reduce((a, value) => a + value, 0); 
    this.totalRemise=0;
    this.totalRemise = this.RemisesFiltered.map((t) => t.remise * 1).reduce((a, value) => a + value, 0); 
    this.totalAvance=0;
    this.totalAvance = this.PaiementsFiltered.map((t) => t.avance * 1).reduce((a, value) => a + value, 0); 
    this.totalAvoir=0;
    this.totalAvoir = this.AvoirsFiltered.map((t) => t.avoir * 1).reduce((a, value) => a + value, 0); 
    this.totalCharge=0;
    this.totalCharge = this.ChargesFiltered.map((t) => t.charge * 1).reduce((a, value) => a + value, 0); 
    
    this.DonneesFiltered.forEach((value,index) => {
      label.push(value.label);
      donnee.push(value.data);
      let updateItem = this.ChargesFiltered.find(item=>item.label==value.label);
      // console.log(updateItem);
      if (updateItem!=undefined){
        // console.log( updateItem.charge);        
        this.DonneesFiltered[index].charge = updateItem.charge;
        charge.push(updateItem.data);
      }else{
        this.DonneesFiltered[index].charge = 0;
      }
      
      // console.log(this.AvoirsFiltered);
      let updateItem2 = this.AvoirsFiltered.find(item=>item.label==value.label);
      // console.log(updateItem2);
      if (updateItem2!=undefined){
        this.DonneesFiltered[index].avoir = updateItem2.avoir;
        avoir.push(updateItem2.data);
      }else{
        this.DonneesFiltered[index].avoir = 0;
      }

      let updateItem3 = this.PaiementsFiltered.find(item=>item.label==value.label);
      // console.log(updateItem3);
      if (updateItem3!=undefined){
        this.DonneesFiltered[index].avance = updateItem3.avance;
        avance.push(updateItem3.data);
      }else{
        this.DonneesFiltered[index].avance = 0;
      }

      let updateItem4 = this.RemisesFiltered.find(item=>item.label==value.label);
      if (updateItem3!=undefined){
        this.DonneesFiltered[index].remise = updateItem4.remise;
        remise.push(updateItem4.data);
      }else{
        this.DonneesFiltered[index].remise = 0;
      }
    });
    this.basicData = {
      labels: label,
      datasets: [
        {
          label: "المبيعات",
          backgroundColor: "#42A5F5",
          borderColor: "#1E88E5",
          data: donnee,
        },
        {
          label: "الصوائر",
          backgroundColor: "#a6277b",
          borderColor: "#a6277b",
          data: charge,
        },
        {
          label: "الرجوع",
          backgroundColor: "#13db60",
          borderColor: "#13db60",
          data: avoir,
        },
        {
          label: "التسبيق",
          backgroundColor: "red",
          borderColor: "red",
          data: avance,
        },
      ],
    };
  }
  findNameDepot(idDepot){
    this.Depots 
    let updateItem = this.Depots.find(item=>item.id==idDepot);
    if(updateItem){
      return updateItem.designation;
    }else{

    }
    
  }
}
